













import Vue from 'vue'
import html2canvas from 'html2canvas'
import Icon from '@/components/Icon/Icon.vue'

import type { Point } from '@/@types'

interface Data {
  isOpen: boolean
  minimapImg: string
  minimapStyles: Record<string, string>
  viewportStyles: Record<string, string>
}

interface Methods {
  changeViewportZoom: () => void
  changeViewportPosition: () => void
  changeMinimapSize: () => void
  setMinimapContent: () => void
  handleToggleOpen: () => void
}

interface Computed {
  contentElement: HTMLDivElement | undefined
}

interface Props {
  mapUpdate: number
  scaleContent: number
  scaleMap: number
  viewPoint: Point
  getContentElement?: () => HTMLDivElement | undefined
}

export default Vue.extend<Data, Methods, Computed, Props>({
  components: {
    Icon,
  },
  props: {
    mapUpdate: {
      default: () => 0,
    },
    scaleContent: {
      default: () => 1,
    },
    scaleMap: {
      default: () => 6,
    },
    viewPoint: {
      default: () => ({ x: 0, y: 0 }),
    },
    getContentElement: {
      default: () => () => undefined,
    },
  },
  data() {
    return {
      isOpen: false,
      minimapImg: '',
      minimapStyles: {},
      viewportStyles: {},
    }
  },
  computed: {
    contentElement() {
      return this.getContentElement?.()
    },
  },
  methods: {
    changeViewportZoom() {
      const { clientWidth = 0, clientHeight = 0 } = this.contentElement || {}

      this.viewportStyles = {
        ...this.viewportStyles,
        width: `${clientWidth / this.scaleContent / this.scaleMap}px`,
        height: `${clientHeight / this.scaleContent / this.scaleMap}px`,
      }
    },
    changeViewportPosition() {
      this.viewportStyles = {
        ...this.viewportStyles,
        top: `${this.viewPoint.y / this.scaleContent / this.scaleMap}px`,
        left: `${this.viewPoint.x / this.scaleContent / this.scaleMap}px`,
      }
    },
    changeMinimapSize() {
      const { scrollWidth = 0, scrollHeight = 0 } = this.contentElement || {}

      this.minimapStyles = {
        width: this.isOpen ? `${scrollWidth / this.scaleMap}px` : '0px',
        height: this.isOpen ? `${scrollHeight / this.scaleMap}px` : '0px',
      }
    },
    setMinimapContent() {
      this.$nextTick(() => {
        if (!this.contentElement) {
          return
        }

        html2canvas(this.contentElement, {
          logging: false,
          scale: 1,
          x: 0,
          y: 0,
          width: this.contentElement.scrollWidth,
          height: this.contentElement.scrollHeight,
          onclone: (document, element) => {
            element.style.removeProperty('transform')
          },
        }).then(canvas => {
          this.minimapImg = canvas.toDataURL()
          this.changeMinimapSize()
          this.changeViewportZoom()
          this.changeViewportPosition()
        })
      })
    },
    handleToggleOpen() {
      this.isOpen = !this.isOpen
      this.changeMinimapSize()
      this.changeViewportZoom()
      this.changeViewportPosition()
    }
  },
  mounted: function() {
    this.setMinimapContent()
  },
  watch: {
    mapUpdate() {
      this.setMinimapContent()
    },
    viewPoint() {
      this.changeViewportPosition()
    },
    scaleContent() {
      this.changeViewportZoom()
    },
  },
})
